import { render, staticRenderFns } from "./createCard.vue?vue&type=template&id=f756edf8&scoped=true&"
import script from "./createCard.vue?vue&type=script&lang=js&"
export * from "./createCard.vue?vue&type=script&lang=js&"
import style0 from "./createCard.vue?vue&type=style&index=0&id=f756edf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f756edf8",
  null
  
)

export default component.exports